module.exports = __webpack_public_path__ + "img/icon_FAQ_verify_inactive.e706c2b9.svg";